import httpService from "core/infrastructure/http";
import { ApplicationState } from "core/app";
import { PageList } from "core/pages/pageList";


export const mapUpTo = <T>(n: number, fn: (idx: number) => T) => {
    var arr = [];
    for (var i = 0; i < n; i++) {
        arr.push(fn(i));
    }
    return arr;
};

export const makePageChange = (pageNumber: number, applicationState: ApplicationState, data: any, setPageNumber: (num: number) => void, makeRequest: (skip: number, take: number) => void) => {
    setPageNumber(pageNumber);
    const rows = applicationState.maxRows * pageNumber;
    if (data.skip > rows || rows >= data.take) {
        let skip = Math.floor(pageNumber / 10) * applicationState.pageSize;
        makeRequest(skip, skip + applicationState.pageSize);
    }
}

export const makeRequest = async <T> (skip: number, take: number, applicationState: ApplicationState, initialData: T, search: any, senderId: string, page_config: PageList, setLoading: (loading: boolean) => void, setError: (error: string) => void, setData: (data: T) => void) => {
    setLoading(true);
    setData(initialData);
    const response = await httpService.apiPost<T>({
        applicationState: applicationState,
        route: applicationState.apiService + "/" + page_config.apiType + "/" + page_config.apiUrl,
        query: {
            FromUtc: applicationState.selectedDate.toISOString(),
            ToUtc: page_config.getDefaultToDateTime(applicationState).toISOString(),
            Filter: search,
            Skip: skip, Take: take
        },
        senderId: senderId
    })();

    if (response.ok) {
        setData(response.data);
        setError("");
    } else {
        setError(response.error || "An unknown error occured."); //TODO
    }
    setLoading(false);
}

export const replaceArray = (str: string, find: string[], replace: string) => {
    for (let i = 0; i < find.length; ++i) {
        str = str.replace(find[i].toLowerCase(), replace.toLowerCase());
    }
    return str;
};